import { Processor } from "./processor.model";

export enum PaymentMethodTypes {
  BANK_ACCOUNT,
  DOCUMENT,
  EMAIL,
  PHONE,
};

export type Investor = {
  id?: string;
  name: string;

  minInstallments?: number | null;
  minAge?: number | null;
  maxAge?: number | null;
  minValue?: number | null;
  maxValue?: number | null;
  interest?: number | null;

  paymentMethods?: PaymentMethodTypes[] | null;

  createdAt?: Date;
  processors?: Processor[];
};
